/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import Button from '../elements/Button';

export default function BrandIcon() {
  return (
    <Button
      className="group inline-flex items-center gap-2"
      type="link"
      href="/"
    >
      {/* DNS Computer Logo */}
      <img
        src="/dns-computer-logo.png"
        alt="DNS Computer"
        className="h-10 sm:h-12 lg:h-14 w-auto object-contain"
      />
    </Button>
  );
}
